module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "homeBanner",
    attrs: {
      "id": "home-banner"
    }
  }, [_c('plex-header'), _vm._v(" "), _c('div', {
    staticClass: "content",
    attrs: {
      "id": "home-banner-content"
    }
  }, [_c('div', {
    staticClass: "left-banner"
  }, [_c('div', {
    staticClass: "trust"
  }, [(_vm.$store.state.currentLang === 'en') ? _c('img', {
    staticClass: "banner-trust h1-pc",
    attrs: {
      "src": "/static/activityImg/7-day-trust-en.png"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.currentLang === 'zh') ? _c('img', {
    staticClass: "banner-trust h1-pc",
    attrs: {
      "src": "/static/activityImg/7-days-trust-zh.png"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.currentLang === 'en') ? _c('img', {
    staticClass: "banner-trust h1-phone",
    attrs: {
      "src": "/static/activityImg/7-day-trust-en-h5.png"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.currentLang === 'zh') ? _c('img', {
    staticClass: "banner-trust h1-phone",
    attrs: {
      "src": "/static/activityImg/7-day-trust-zh-h5.png"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "banner-title"
  }, [_c('h1', {
    ref: "pcTitle",
    staticClass: "h1-pc"
  }, [_vm._v(_vm._s(_vm.$t("pcTitle[0]")))]), _vm._v(" "), _c('h1', {
    ref: "pcTitle",
    staticClass: "h1-pc"
  }, [_vm._v(_vm._s(_vm.$t("pcTitle[1]")))]), _vm._v(" "), _c('h1', {
    ref: "phoneTitle",
    staticClass: "h1-phone",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('phoneTitle'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('bannerDes'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "banner-btn"
  }, [_c('router-link', {
    staticClass: "get-plex",
    attrs: {
      "to": !_vm.hasToken ? '/register' : '/dashboard'
    }
  }, [_vm._v(_vm._s(_vm.$t("signUp")))])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cad6fb16!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/homeBanner/HomeBanner.vue
// module id = 1389
// module chunks = 1